import React from 'react';
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Typography,
  Box
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { UnknownAction } from '@reduxjs/toolkit';
import { henryOxfordSelection } from '../../../../shared/shared.constants';

const RadioButtons = ({
  BMRVal,
  activityFactor,
  setActivityFactor
}: {
  BMRVal: number;
  activityFactor: {
    optionSelected: string;
    value: number;
    bmrPlusActivityFactor: number;
  };
  setActivityFactor: (val: {
    optionSelected: string;
    value: number;
    bmrPlusActivityFactor: number;
  }) => UnknownAction;
}) => {
  const dispatch = useDispatch();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(
      setActivityFactor({
        value: henryOxfordSelection.activityFactor[`${event.target.value}`].min,
        optionSelected: event.target.value,
        bmrPlusActivityFactor: Number(
          (
            (BMRVal *
              henryOxfordSelection.activityFactor[`${event.target.value}`]
                .min) /
              100 +
            BMRVal
          ).toFixed(2)
        )
      })
    );
  };
  const options = [
    { label: 'Bedbound immobile', percentage: '10%', value: 'immobile' },
    {
      label: 'Bedbound mobile/Sitting',
      percentage: '15 - 20%',
      value: 'mobileSitting'
    },
    { label: 'Mobile on ward', percentage: '25%', value: 'mobileWard' }
  ];

  return (
    <>
      <FormControl component="fieldset" sx={{ width: '100%' }}>
        <RadioGroup
          value={activityFactor.optionSelected}
          onChange={handleChange}
        >
          {options.map((option) => (
            <Box
              key={option.label}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              sx={{
                padding: '0.5rem'
              }}
            >
              <FormControlLabel
                value={option.value}
                control={
                  <Radio
                    icon={
                      <Box
                        sx={{
                          borderRadius: '50%',
                          width: 14,
                          height: 14,
                          border: '0.0625rem solid #D9D9D6'
                        }}
                      />
                    }
                    checkedIcon={
                      <Box
                        sx={{
                          borderRadius: '50%',
                          width: 14,
                          height: 14,
                          backgroundColor: '#004F71'
                        }}
                      />
                    }
                  />
                }
                label={
                  <Typography sx={{ fontFamily: 'Calibri' }} variant="body1">
                    {option.label}
                  </Typography>
                }
              />
              <Box
                sx={{
                  backgroundColor:
                    activityFactor.optionSelected === option.value
                      ? '#007ACC'
                      : '#fff',
                  color:
                    activityFactor.optionSelected === option.value
                      ? '#fff'
                      : '#007ACC',
                  padding: '0.3125rem 0.9375rem 0.3125rem 0.9375rem',
                  borderRadius: '1rem',
                  border: '0.125rem solid #007ACC'
                }}
              >
                {option.percentage}
              </Box>
            </Box>
          ))}
        </RadioGroup>
      </FormControl>
    </>
  );
};

export default RadioButtons;
